import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectors, getAll, addItem, updateItem } from '../../../redux/companyQboTaxAccounts';

export default function useQuickbookTaxAccount() {
    const dispatch = useDispatch();
    const reduxState = useSelector(state => state.companyQboTaxAccounts);
    const items = selectors.selectAll(reduxState);

    useEffect(() => {
        dispatch(getAll());
    }, [dispatch]);

    const save = useCallback((item) => {

        const updateCall = async () => {
            console.log('save qbo tax account item', item);
            if (item.qbo_tax_account_id) {
                await dispatch(updateItem({ id: item.qbo_tax_account_id, ...item }));
            } else {
                await dispatch(addItem({ ...item }));
            }
        };

        updateCall();
    }, [dispatch]);

    return [
        items,
        save,
    ];
};
